import type { RouteIdType } from './routeDefinitions';
import { RouteId } from './routeDefinitions';

const cardRoutes = new Set<string>([RouteId.CARD]);

export const isCardRoute = (routeId: RouteIdType): boolean =>
  cardRoutes.has(routeId);
